var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('base-wrapper',{attrs:{"variant":"fullscreen"}},[_c('shared-plan-header',{on:{"plan:create":_vm.createPlan}}),_c('shared-plan-list',{attrs:{"plans":_vm.plans}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }